import React from 'react';
import ArrowBack from "@images/profile/arrow_back.svg";
import { DateTime } from 'luxon';

const NftDetails = ({ nft, close }) => {

  const name = nft?.content?.metadata?.name;
  const description = nft?.content?.metadata?.description;
  const city = nft?.content?.metadata?.attributes?.find(attr => attr.trait_type === 'city')?.value;
  const timestamp = nft?.content?.metadata?.attributes?.find(attr => attr.trait_type === 'timestamp')?.value;
  const image = nft?.content?.links?.image
  const formattedTimestamp = typeof timestamp === 'number' ? DateTime.fromSeconds(timestamp).toFormat('yyyy-MM-dd HH:mm:ss') : '---';

  return (
    <div>
      <div className="flex justify-between items-center w-full">
        <button onClick={close} className="bg-black px-[12px] text-[16px] py-[10px] text-white flex gap-[4px] rounded-full">
          <img src={ArrowBack} alt="Go back" /> Go back
        </button>
      </div>
      <div className="flex flex-col gap-[10px]">
        <p className="text-black text-[42px] leading-[42px] font-semibold text-center">
          {name}
        </p>
        <div className="w-full h-full bg-white rounded-2xl p-[16px] flex flex-col justify-center items-center gap-[16px]">
          <p className="text-black text-[24px] leading-[32px]">Description: {description || '---'}</p>
          <p className="text-black text-[24px] leading-[32px]">City: {city || '---'}</p>
          <p className="text-black text-[24px] leading-[32px]">Timestamp: {formattedTimestamp || '---'}</p>
          <img src={image} alt={name} className="w-[60px] h-[60px] rounded-[8px]" />
        </div>
      </div>
    </div>
  )
}

export default NftDetails
